import { IsolatedScan, IsolatedScanTHzMetadata } from "../types/types";
import { genericRequest, isolatedScanRoute } from "./service";

/**
 * Gets a list of isolated scans related to a given section.
 * 
 * @param sectionScanId of the isolated scans to fetch
 * 
 * @returns list of all isolated scans for a section
 */
export const getIsolatedScans = async (sectionScanId: number): Promise<IsolatedScan[] | Error> => {
  return await genericRequest({ url: `${isolatedScanRoute}/isolated_scans/${sectionScanId}`, method: "GET" })
}

/**
 * Gets metadata for isolated scans related to a given section.
 * 
 * @param sectionScanId of the isolated scans metadata to fetch
 * 
 * @returns metadata for all isolated scans in the section
 */
export const getIsolatedScanMetadata = async (sectionScanId: number): Promise<IsolatedScanTHzMetadata[] | Error> => {
  return await genericRequest({ url: `${isolatedScanRoute}/isolated_scans/metadata/${sectionScanId}`, method: "GET" })
}

/**
 * Adds a new isolated scan to a given section.
 * @param isolatedScan to add
 * @param sectionScanId of the section to add the scan to
 * 
 * @returns the added isolated scan or an error
 */
export const addIsolatedScan = async (isolatedScan: IsolatedScan, sectionScanId: number): Promise<IsolatedScan | Error> => {
  const body = JSON.stringify(isolatedScan)
  return await genericRequest({ url: `${isolatedScanRoute}/${sectionScanId}`, method: "POST", body: body })
}
